import { prepareFilter } from "@actions";
import prepareDetails from "@helpers/prepareDetails";
import axios from "@common/api/desktop/axios";

class Transactions {
  getTickets = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
    pageNumber,
  ) => {
    const response = await axios.put(
      `transactions/byOrg/filter/tickets`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
        pageNumber,
      ),
    );
    return response.data;
  };

  getTicketsSummary = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
  ) => {
    const response = await axios.put(
      `transactions/byOrg/summary/tickets`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
      ),
    );
    return response.data;
  };

  getLiability = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
    pageNumber,
  ) => {
    const response = await axios.put(
      `Transactions/byOrg/filter/liabilities`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
        pageNumber,
      ),
    );
    return response.data;
  };

  getLiabilitySummary = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
  ) => {
    const response = await axios.put(
      `Transactions/byOrg/summary/liabilities`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
      ),
    );
    return response.data;
  };

  getKiosk = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
    pageNumber,
  ) => {
    const response = await axios.put(
      `Transactions/byOrg/filter/transactions`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
        pageNumber,
      ),
    );
    return response.data;
  };

  getKioskSummary = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
  ) => {
    const response = await axios.put(
      `Transactions/byOrg/summary/transactions`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
      ),
    );
    return response.data;
  };

  getTicketsExport = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
  ) => {
    const response = await axios.put(
      `Transactions/export/tickets`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
      ),
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getKioskExport = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
  ) => {
    const response = await axios.put(
      `Transactions/export/transactions`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
      ),
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getLiabilityExport = async (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
  ) => {
    const response = await axios.put(
      `Transactions/export/liabilities`,
      this.prepareData(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        Details,
      ),
      { responseType: "arraybuffer" },
    );
    return response;
  };

  getFilterTypes = async () => {
    const response = await axios.get(
      "Transactions/options/tickets/asset/filtertype",
    );
    return response.data;
  };

  getFilterList = async (operatorId, siteId, type) => {
    const response = await axios.get(
      `Transactions/options/tickets/assets/filterlist/${operatorId},${siteId},${type}`,
    );
    return response.data;
  };

  prepareData = (
    useCollectionWeek,
    searchParams,
    filterSelected,
    filterData,
    Details,
    pageNumber,
  ) => {
    const { operator, company, subcompany, site } = filterSelected;
    return {
      // Search params
      StartDate: searchParams.startDate,
      EndDate: searchParams.endDate,
      IncludeEvents: searchParams.includeEvents || false,
      SessionId: parseInt(searchParams.sessionId) || -1,
      TransactionRef: searchParams.transactionRef || "#",
      AssetNo: searchParams.assetNo || "#",
      PlayerId: searchParams.playerId || "#",
      pageNumber,
      UserName: searchParams.username || "#",
      collectionWeek: useCollectionWeek === 3 ? searchParams.week : null,
      useCurrentWeek: useCollectionWeek === 1 ? true : false,
      TicketSerial: searchParams.ticketSerial,
      filterType: searchParams.selectedFilterType.toString(),
      filterValue: searchParams.selectedFilterValue.toString(),

      // Selected company etc from the org tree
      OperatorId: operator,
      CompanyId: company.id || -1,
      SubCompanyId: subcompany.id || -1,
      SiteId: site.id || -1,

      // Selected filters from the org tree
      OperatorRegions: prepareFilter(
        filterSelected.regions,
        filterData.regions,
      ),
      Manufacturers: prepareFilter(
        filterSelected.manufacturer,
        filterData.manufacturer,
      ),
      GameNames: prepareFilter(filterSelected.game, filterData.game),
      Categories: prepareFilter(
        filterSelected.machinetypes,
        filterData.machinetypes,
      ),

      // Filters from the summary;
      Details: prepareDetails(Details),
    };
  };
}

const transactions = new Transactions();
export default transactions;
